export const infoData = [
  { id: "ready", name: "READY" },
  { id: "unknown", name: "UNKNOWN" },
  { id: "aborted", name: "ABORTED" },
  { id: "unlicenced", name: "UNLICENCED" },
  { id: "badargs", name: "BAD ARGS" },
  { id: "noaddress", name: "NO ADDRESS" },
  { id: "badaddrrange", name: "BAD ADDR RANGE" },
  { id: "internalerror", name: "INTERNAL ERROR" },
  { id: "inprogress", name: "IN PROGRESS" },
  { id: "passed2", name: "PASSED" },
  { id: "conflictsfound", name: "CONFLICTS FOUND" }
];
